import { getErrorMessage } from './validations';

export default {
  props: {
    value: { required: true, type: null, default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: null },
    fullWidth: { type: Boolean, default: false },
    name: { type: String, default: null },
    inputId: { type: String, default: null },
    autocomplete: { type: String, default: null },
    size: { type: String, default: null },
    type: { type: String, default: 'text' },
    block: { type: Boolean, default: false },
    v: { type: Object, required: false, default: null },
  },
  data() {
    return {
      currentValue: this.value,
      showTitle: false,
      focused: false,
    };
  },
  computed: {
    autoErrorMessage() {
      if (this.errorMessage) {
        return this.errorMessage;
      }
      return getErrorMessage(this.v);
    },
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
  },
  mounted() {
    this.setCurrentValue(this.value);
  },
  methods: {
    async focus() {
      const el = this.$el.querySelector('input');
      if (el) {
        el.focus();
      }
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    clear() {
      this.$emit('input', null);
      this.$emit('change', null);
      this.setCurrentValue(null);
    },
    handleInput(event) {
      let value = event;
      if (typeof event === 'object') {
        ({ value } = event.target);
      }

      if (this.isNumeric) {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
          value = parsed;
        }
      }

      this.$emit('input', value);
      this.$emit('change', value);
      this.setCurrentValue(value);

      if (value) {
        this.showTitle = !this.hideTitle && this.placeholder !== null;
      } else if (!value) {
        this.showTitle = false;
      }
    },
    handleChange(event) {
      this.$emit('change', event.target.value);
    },
    handleFocus() {
      this.showTitle = !this.hideTitle && this.placeholder !== null;
      this.focused = true;
      this.$emit('focus', this);
    },
    handleBlur() {
      this.showTitle = false;
      this.focused = false;

      if (this.validator) {
        this.validator.$touch();
      }

      this.$emit('blur', this);
    },
  },
};
